import React, { createContext, useContext, useState } from 'react';

import { SESSION_STORAGE_HIDDEN_BANNER, TRUE_STRING } from '@/common/constants';
import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';

const BannerContext = createContext(null);

export const BannerContextProvider = ({ children }) => {
  const [isHiddenBanner, setIsHiddenBanner] = useState(
    sessionStorage.getItem(SESSION_STORAGE_HIDDEN_BANNER) === TRUE_STRING,
  );

  const handleHideBanner = () => {
    sessionStorage.setItem(SESSION_STORAGE_HIDDEN_BANNER, true);

    setIsHiddenBanner(true);
  };

  return (
    <BannerContext.Provider
      value={{
        handleHideBanner,
        isHiddenBanner,
      }}
    >
      {children}
    </BannerContext.Provider>
  );
};

export const useBannerContext = () => useContext(BannerContext);

BannerContextProvider.defaultProps = {
  ...ChildrenDefaultProps,
};

BannerContextProvider.propTypes = {
  ...ChildrenPropTypes,
};
